import React from 'react';
import { useSelector } from 'react-redux';
import { FormattedMessage } from 'react-intl';
import { FormattedCurrencyContainer } from '../../../../../../components/formatted-currency/container';

import { Text } from 'ui-components/components/text/text';
import { TextType } from 'ui-components/components/text/text-type';
import Global from '../../../../../../store/global-selectors';
import { useManageSubscriptionDrawerContext } from '../../../context/manage-subscription-drawer-context';
import {
  getNonWalletAccessDisplayPrice,
  getNonWalletAccessDisplayPriceNote,
  NonWalletAccessBillingState,
  useIsByoaPriceUnknownDuringTrial,
  useNonWalletAccessBillingState,
} from '../../../../../../hooks/non-wallet-access-hooks';
import { useSelectedBasePlan } from '../../../hooks/use-plan-details';
import { messages } from './messages';
import style from './style.module.css';

export const CollapsibleYourCarriersHeader = () => {
  const { byoaEnabled } = useManageSubscriptionDrawerContext();
  const subscriptionData = useSelector(Global.selectSellerSubscriptionData);
  const { planToNonWalletAccessPlanMap = {} } = subscriptionData ?? {};

  const selectedPlan = useSelectedBasePlan();

  const byoaPlan = planToNonWalletAccessPlanMap?.[selectedPlan?.billingPlanId];
  const byoaBillingState = useNonWalletAccessBillingState();
  const isByoaFree = byoaBillingState === NonWalletAccessBillingState.Included;
  const isByoaPriceUnknown = useIsByoaPriceUnknownDuringTrial(selectedPlan);
  const byoaPrice = byoaEnabled && !isByoaFree ? getNonWalletAccessDisplayPrice(selectedPlan, byoaPlan) : 0;
  const byoaLabel = byoaEnabled ? <FormattedMessage {...messages.active} /> : <FormattedMessage {...messages.inactive} />;
  const priceNote = isByoaFree ? '' : getNonWalletAccessDisplayPriceNote(selectedPlan);
  return (
    <div className={style['your-carriers-header']}>
      <Text textType={TextType.H3} value={<FormattedMessage {...messages.yourCarriersSelectionTitle} />} />
      <div className={style['your-carriers-price']}>
        <Text textType={TextType.Caption} value={byoaLabel} />
        <Text
          textType={TextType.H3}
          value={
            isByoaPriceUnknown ? (
              <FormattedMessage {...messages.yourCarriersFreeLabel} />
            ) : (
              <>
                <FormattedCurrencyContainer currencyCode={byoaPlan?.pricePerPeriod?.code} fractionDigits={2} value={byoaPrice} />
                {priceNote}
              </>
            )
          }
        />
      </div>
    </div>
  );
};
